import { IDetailPageData } from "../../../shared/utils/api";
import { IObject } from "../../../shared/utils/utils";

interface IEnumerationDatamodelField {
  id: string;
  value: string;
}

export interface IEnumerationBackendType {
  id: string;
  name: string;
  fields: IEnumerationDatamodelField[];
}

export function transformFromBackendEnumeration(backendType: IEnumerationBackendType): IDetailPageData {
  return {
    id: backendType.id,
    name: backendType.name,
    rowData: [],
    options: backendType.fields.map(field => (
      {
        id: field.id,
        value: field.value
      }))
  };
}

export function transformToBackendEnumeration(data: IDetailPageData): IEnumerationBackendType | undefined {
  if (!data.id || !data.name) {
    return undefined;
  }
  
  return {
    id: data.id,
    name: data.name,
    fields: data.options.map((option: IObject) => ({
      id: option.id,
      value: option.value,
    }))
  };
}
